<!-- src/App.vue -->
<template>
  <div id="app">
    <router-view /> <!-- This will load the layout components based on the route -->
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
/* Add your global styles here */
</style>
